import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { CheckoutModule, PaymentWalletButtonModule } from '@platform-frontend/checkout';
import { CountryModule, SaasApiKeyModule } from '@platform-frontend/marketplace';
import {
  ButtonModule,
  CommonWordingModule,
  CountdownModule,
  E2EVisibleModule,
  IconsModule,
  LinkModule,
  LoadingIndicatorModule,
  TemplateVariablesModule,
  TooltipModule,
  icoChevronLeft,
  icoChevronRight,
  icoCopy
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { LottieComponent } from 'ngx-lottie';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { CommercialCommonModule } from '../commercial-common/commercial-common.module';
import { AddFirstPaymentMethodComponent } from './add-first-payment-method/add-first-payment-method.component';
import { BillingAddressSelectionComponent } from './billing-address-selection/billing-address-selection.component';
import { BillingAddressComponent } from './billing-address/billing-address.component';
import { ConfirmationVendorInstructionsComponent } from './confirmation-vendor-instructions/confirmation-vendor-instructions.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { SuccessLottiePathPipe } from './confirmation/sucess-lottie-path.pipe';
import { OverviewComponent } from './overview/overview.component';
import { PaymentMethodSelectionComponent } from './payment-method-selection/payment-method-selection.component';
import { PersonalizationModule } from './personalization/personalization.module';

@NgModule({
  declarations: [
    AddFirstPaymentMethodComponent,
    BillingAddressComponent,
    BillingAddressSelectionComponent,
    ConfirmationComponent,
    ConfirmationVendorInstructionsComponent,
    OverviewComponent,
    PaymentMethodSelectionComponent,
    SuccessLottiePathPipe
  ],
  exports: [AddFirstPaymentMethodComponent, BillingAddressComponent, BillingAddressSelectionComponent, OverviewComponent, PaymentMethodSelectionComponent],
  imports: [
    ButtonModule,
    CheckoutModule,
    CommonModule,
    CommonWordingModule,
    CommercialCommonModule,
    CountdownModule,
    CountryModule,
    E2EVisibleModule,
    IconsModule.withIcons(icoChevronLeft, icoChevronRight, icoCopy),
    LinkModule,
    LoadingIndicatorModule,
    LottieComponent,
    MatomoTrackClickDirective,
    PaymentWalletButtonModule,
    PersonalizationModule,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    SaasApiKeyModule,
    TemplateVariablesModule,
    TranslocoLocaleModule,
    TranslocoMarkupModule,
    TranslocoModule,
    TooltipModule
  ]
})
export class CommercialCheckoutModule {}
